/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * HE ISR resource file
 */
export const labels = {
    title: "EY Canvas Economics",
    status: "סטטוס",
    header: "כותרת",
    canvas: "Canvas",
    canvasEconomics: "כלכלת Canvas",
    badRequest: "בקשה שגויה",
    errorBanner: "{ 0} שגיאה/ות",
    userProfileDropdown: {
        myProfile: "הפרופיל שלי",
        signOut: "התנתקות"
    },
    clientCode: "קוד לקוח",
    hours: "שעות",
    local: "מקומי",
    currency: "מטבעות",
    rate: "שיעור",
    forecast: "תחזית",
    variance: "שונות",
    edit: "ערוך",
    arrowUp: "חץ למעלה",
    budget: "תקציב",
    priorBudget: "תקציב קודם",
    currentBudget: "תקציב נוכחי",
    summary: "סיכום",
    actual: "בפועל",
    priorActual: "בפועל - תקופה קודמת",
    currentActual: "בפועל - תקופה נוכחית",
    remaining: "נותר",
    adjustment: "התאמה",
    estimate: "אומדן",
    isRequired: "נדרש {0}",
    isPositiveInteger: "{0} נדרש ועליו להיות מספר שלם שאינו שלילי.",
    isPositiveDecimal: "{0} נדרש ועליו להיות מספר חיובי עם 2 ספרות עשרוניות.",
    in: "ב",
    id: "ID",
    currentYear: "שנה נוכחית",
    priorYear: "שנה קודמת",
    budgetHierarchy: "היררכיית תקציב",
    executionBudgetHierarchy: "היררכיית תקציב ביצוע",
    noContentAvailable: "אין תוכן זמין",
    viewMore: "הצג עוד",
    budgetExecutionPhase: "תקציב עבור כל האובייקטים בתוך {0}",
    details: "פרטים",
    unallocated: "לא הוקצה",
    none: "אף אחד",
    thousands: "אלפים",
    millions: "מיליונים",
    lakhs: "Lakhs",
    crores: "Crores",
    budgetObjectName: "שם אובייקט תקציב",
    editActivityCodes: "ערוך קודי פעילות",
    save: "שמור",
    send: "לִשְׁלוֹחַ",
    cancel: "בטל",
    searchActivityCodes: "חפש קודי פעילות",
    noActivityCodesAvailable: "אין קודים זמינים לפעילות",
    select: "בחר",
    engagementCode: "קוד התקשרות",
    engagementCodeName: "שם קוד ההתקשרות",
    activityCode: "קוד פעילות",
    activityCodeDescription: "תיאור קוד פעילות",
    searchActivityCodesPlaceholderText: "חפש קודי פעילות",
    addMember: "הוסף חבר",
    closeLabel: "Close",
    cancelLabel: "בטל",
    seachInputRequired: "חפש קלט שנדרש",
	nameOrEmail: 'שם או דוא"ל',
	emailForExternal: "דואל",
	noRecord: "לא נמצאו תוצאות",
	userSearchPlaceholder: 'הזן שם או דוא"ל ולחץ Enter כדי לראות תוצאות.',
	userSearchPlaceholderForExternal: 'הזן דוא"ל ולחץ Enter כדי לראות תוצאות.',
	clearAllValues: "נקה את כל הערכים",
	clear: "Clear",
	inValidEmail: 'אנא הזן דוא"ל חוקי',
    invalidClientCode: "קוד לקוח לא חוקי",
    railSearchText: "חפש",
    open: "פתח",
    remove: "הסר",
    leave: "לעזוב",
    delete: "מחק",
    markAsCompleted: "סמן כהושלם",
    budgetedHours: "שעות מתוקצבות",
    forecastedHours: "שעות צפויות",
    actualHours: "שעות בפועל",
    ftaVariance: "שונות FTA (שונות מול בפועל)",
    ftaVarianceTooltip: "תחזית לשונות מול בפועל",
    usedHours: "שעות בשימוש",
    etcHours: "שעות ETC",
    createProjectCard: "צור פרוייקט",
    plusClients: "+ {0} לקוחות",
    plusCodes: "+ {0} קודי לקוח",
    clientNames: "שמות לקוחות:",
    clientName: "שם לקוח:",
    clientNameLabel: "שם הלקוח",
    clientCodes: "קודי לקוח:",
    clientCodeCard: "קוד לקוח:",
    financialAnalysis: "ניתוח פיננסי",
    billingExpenses: "חיוב והוצאות",
    independence: "אי תלות",
    timeChargedCanvasIndependenceStatus: "סטטוס אי התלות הכולל של פרויקט לפי EY Canvas וקוד כספי (Financial Code)",
    independenceStatusFromCanvasLabel: "סטטוס אי תלות מ-EY Canvas",
    independenceRequired: "נדרשת בחינת אי תלות",
    validatedCanvas: "אימות ב-EY Canvas",
    notInvited: "לא הוזמן",
    notApplicable: "לא ישים",
    incomplete: "לא שלם",
    other: "אַחֵר",
    financialCodesDisplayed: "קודים כספיים מוצגים",
    independenceStatusChangeReasonLabel: "שנה סטטוס",
    independenceStatusChangeReasonDescription: "בחר את סיבת ההשלמה עבור חבר הצוות שנבחר",
    changeReasonLabel: "סיבה",
    clarificationLabel: "הבהרה (אופציונלי)",
    characterCount: "{0} מתוך 200 תווים",
    expandAll: "הרחב הכל",
    collapseAll: "צמצם הכל",
    canvasEngagements: "התקשרויות של EY Canvas",
    independenceCompleted: "בחינת אי התלות הושלמה",
    engagementName: "שם תיק הביקורת",
    engagementIndependenceStatus: "לפי סטטוס אי התלות של תיק הביקורת",
    noAssociatedClients: "אין לקוח משויך",
    noCanvasEngagementsIdentified: "לא זוהו התקשרויות של EY Canvas",
    placeholderForSearch: "חפש חבר צוות",
    exportToExcel: "יצוא ל - Excel",
    all: "כל",
    updateSelected: "עדכון נבחר",
    updateAll: "עדכן הכל",
    customizeTable: "התאמה אישית של טבלה",
    canvasEngagementName: "שם תיק הביקורת ב- EY Canvas",
    displayBy: "הצג נתונים לפי",
    financialDetails: "נתונים פיננסיים",
    actualHoursToDate: "שעות בפועל עד היום",
    byWeekEndingDate: "לפי תאריך סיום בשבוע",
    ClickAndDrag: "לחץ וגרור אזור בתרשים בכדי להגדיל את התצוגה",
    etc: "זמן משוער להשלמת",
    auditProgress: "התקדמות ב- EY Canvas",
    tasksAndMilestones: "משימות ואבני דרך",
    milestonesOverdue: "תאריך יעד סיום שלבים בביקורת (Milestones overdue)",
    milestoneOverdue: "תאריך יעד סיום שלבים בביקורת (Milestones overdue)",
    inProgress: "מתבצע",
    inReview: "בסקירה",
    Complete: "המשימות למענה  בביקורת הושלמו",
    assignments: "משימות לביצוע",
    assignment: "משימות לביצוע",
    assignmentsOverdue: "משימות שתאריך היעד שלהן חלף",
    assignmentOverdue: "משימות שתאריך היעד שלהן חלף",
    overdue: "תאריך היעד חלף",
    requestOverdue: "בקשה באיחור",
    requestsOverdue: "בקשות באיחור",
    total: "סך הכול",
    complete: "המשימות למענה  בביקורת הושלמו",
    closed: "סגור",
    Unassigned: "Unassigned",
    unassigned: "unassigned",
    sent: "נשלח",
    totalTask: "סך הכל משימות",
    collaboration: "שיתוף פעולה",
    received: "התקבל",
    accepted: "התקבל",
    outstanding: "יוצא מן הכלל (outstanding)",
    unsentDrafts: "טיוטות שלא נשלחו",
    draft: "טיוטה",
    drafts: "טיוטות",
    returned: "הוחזר",
    draftRequests: "טיוטת בקשות",
    percent: "אחוז",
    preparer: "מכין",
    reviewer: "סוקר ",
    NoDataForSelectedOptions: "אין מידע זמין עבור האפשרויות שנבחרו.",
    NoAssignmentDataForSelectedOptions: "אין שימוש באופציית ההקצאה בתיק הביקורת",
    NoCollabDataForSelectedOptions: "תיק הביקורת אינו משתמש באופציית שיתוף הפעולה עם הלקוחות (Collaboration)",
    tasks: "משימות",
	totalTasks: 'סה"כ משימות',
    requests: "בקשות",
    requestSent: "הבקשות נשלחו",
    requestsSent: "הבקשות נשלחו",
    expandDetails: "הרחב פרטים",
    onlyProjectAdministratorsCanEdit: "רק מנהלי פרויקטים יכולים לערוך",
    onlyProjectAdministratorsCanDelete: "רק מנהלי פרויקטים יכולים למחוק פרויקטים",
    userOptions: "אפשרויות משתמש",
    userOptionsDropdown: {
        userSettings: "הגדרות משתמש",
        delegateAccess: "נהל מיופי כוח",
        privacyNotice: "הודעת פרטיות",
        signOut: "התנתקות"
    },
    delegateToInstruction: "הקצו את הגישה לעמיתים, בכדי שהם יוכלו לאמת את קודי ההתקשרות בשמכם. מיופי כוח אלה יוכלו לאמת את כל קודי ההתקשרויות אליהם יש לך גישה.",
    delegateFromInstruction: "המשתמשים הבאים האצילו את זכויותיהם לאמת קודי התקשרות.",
    delegateAccess: "נהל מיופי כוח",
    addDelegates: "הוסף מיופי כוח",
    addAnother: "הוסף מיופה כוח חדש",
    hideMyDelegate: "הסתר את מיופי הכוח שלי",
    showMyDelegate: "הצג את מיופי הכוח שלי",
    duplicateUser: "מיופה כוח כבר נוסף",
    informationRequired: "המידע הזה נדרש",
    delegateTo: "הוקצה ל",
    delegateFrom: "הוקצה על ידי",
    noDelegatesAdded: "לא נוספו מיופי כוח.",
    noDelegationReceived: "לא התקבלה הקצאה.",
    removeDelegateMessgae: "האם אתה בטוח שברצונך להסיר את מיופי הכוח האלו? לאחר הסרתם, הם כבר לא יוכלו לאמת את קודי ההתקשרות בשמך.",
    removeDelegateTitle: "הסר מיופה כוח",
    delegate: "העבר משימה",
    saveAndClose: "שמור וסגור",
    resetZoom: "אפס ZOOM",
    exportData: "ייצוא נתונים",
	rankCode: "קוד דרגה",
    userGui: "GUI משתמש",
    email: "דואל",
    globalAnsr: " גלובלי ANSR",
    globalCost: "עלות גלובלית",
    globalMargin: "מרווח גלובלי",
    localAnsr: "ANSR מקומי",
    localCost: "עלות מקומית",
    localMargin: "רווחיות מקומית",
    weekEnding: "סוף שבוע",
    welcomeToEconomics: "ברוכים הבאים ל-EY Canvas Economics",
    adminPortal: "פורטל אדמרניסטטיבי",
    home: "בית",
    enterFirstNameText: "הזן שם פרטי, שם משפחה או כתובת דואר אלקטרוני של המשתמש ולחץ על Enter כדי לחפש",
    addBtn: "הוסף ",
    cancelBtn: "בטל",
    close: "Close",
    selectRole: "Role",
    upsText: "אופס!",
    sufficientRightsToAccess: "אין לך מספיק זכויות לגשת לדף זה",
    detailedInformation: "מידע מפורט עשוי להשתנות מנתוני סיכום המוצגים עקב הבדלי תזמון של מועד הצגת הנתונים.",
    noResultFound: "אין תוצאות שתואמות את קריטריוני החיפוש",
    loading: "טוען ...",
    search: "חפש",
    softwareUpdate: "עדכוני תוכנה",
    updateLater: "עדכן מאוחר יותר",
    updateNow: "עדכן כעת",
    updateMsg: "עדכוני תוכנה זמינים עבור EY Canvas Economics. בחר עדכן כעת כדי להוריד ולהתקין את העדכונים. הדף יעבור רענון.",

    eycanvasEngagements: "התקשרויות של EY Canvas",
    eycanvasEngagement: "התקשרות ב- EY Canvas",
    expandView: "הרחב את התצוגה",
    noFinancialCodesDisplay: "אין קודים כספיים זמינים לתצוגה",
    expand: "הרחב",
    collapse: "צמצם",
    bulkSendIndependenceLabel: "שלח הצהרות אי תלות בכמות גדולה",
    independenceStatusInviteUserLabel: "הוסף חבר צוות פנימי לצרכי אי תלות בלבד",
    independenceStatusInviteUserDescription: "זהה את התפקיד של חבר הצוות להלן. משתמש זה יתווסף להתקשרות של {0} Canvas עם הגבלות 'אי תלות בלבד' ויקבל הודעה להשלים את הצהרת אי התלות.",
    clickToInviteUser: "לשלוח הצהרת אי תלות",
    click: "לחץ",
    invitePending: "ההזמנה בהמתנה",
    engagementRolePlaceholder: "תפקיד בהתקשרות",
    engagementRoleRequiredErrorMessage: "אנא בחר את תפקיד ההתקשרות עבור חבר הצוות הנבחר",
    engagementInvitationSuccessToastMessage: "שלחת בהצלחה את הצהרת(ות) אי התלות",
    engagementInvitationFailureToastMessage: "שליחת הצהרת(ות) אי התלות נכשלה, אנא נסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    independenceInviteConfirmationMessage: "נשלחה הצהרת אי תלות. ממתין לתגובה.",
    engagementRoleRequiredOverAllErrorMessage: "תפקיד ההתקשרות לא נבחר עבור משתמש אחד או יותר. בחר את תפקיד ההתקשרות מהתפריט הנפתח כדי להמשיך עם שליחת הצהרת אי התלות.",
    administrativeContractor: "קבלן מנהלי",
};

export const errors = {
    default: "התרחשה שגיאה. אנא צור קשר עם התמיכה הטכנית.",
    102: "פרויקט לא חוקי.",
    106: "אישור RBAC נדחה.",

    1001: "המשתמש לא נמצא.",
    1002: "בקשה לקבלת משתמש נכשלה.",
    1003: "ממשק המשתמש (User GUI) לא יכול להיות לא חוקי (null).",
    1004: "הבקשה אינה יכולה להיות null.",
    1005: "לא ניתן היה ליצור משתמש מכיוון שמשתמש עם אותו קוד עובד (GUI) כבר קיים",
    1006: "נמצא יותר ממשתמש אחד עם אותו קוד עובד (GUI)",
    1007: "המשתמש אינו פעיל. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).",
    1008: "תבנית המספר שנבחרה אינה תבנית חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).",
    1009: "תבנית העיגול שנבחרה אינה תבנית חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).",
    1010: "תבנית המטבע שנבחרה אינה תבנית חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).",
    1011: "תבנית התאריך שנבחרה אינה תבנית חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).",
    1012: "השפה שנבחרה אינה שפה חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).",
    1013: "השם הפרטי הינו קצר מידי או ארוך מידי. אנא נסה שוב.",
    1014: "שם המשפחה הינו קצר מידי או ארוך מידי. אנא נסה שוב.",
    1015: "תבנית המספר השלילי שנבחרה אינה תבנית חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).",
    1016: "לא ניתן היה לעדכן את המשתמש מכיוון שהוא לא קיים.",
    1017: "אירעה שגיאה בעת קבלת העדפות משתמש. בקשת ה- API נכשלה.",
    1018: "אירעה שגיאה בעת יצירת המשתמש. בקשת ה- API נכשלה.",
    1019: "אירעה שגיאה בעת עידכון העדפות המשתמש. בקשת ה- API נכשלה.",
    1020: "המשתמש אינו פעיל. רענן את הדף ונסה שוב. אם השגיאה נמשכת, פנה לתמיכה הטכנית.",
    1021: "ערך הנושא שנבחר אינו ערך חוקי. רענן את הדף ונסה שוב. אם השגיאה ממשיכה, פנה לתמיכה הטכנית.",
    1022: "ערך המטבע שנבחר אינו ערך חוקי. רענן את הדף ונסה שוב. אם השגיאה ממשיכה, פנה לתמיכה הטכנית.",
    1023: "למשתמש אין הרשאה להסיר את חבר הצוות המבוקש מהפרויקט.",
    1024: "אירעה שגיאה בעת יצירת משתמש מיופה הכוח. קריאת ה- API נכשלה.",
    1025: "רשימת המשתמשים מיופי הכוח אינה יכולה להיות ריקה.",
    1026: "שם המשתמש ארוך או קצר מדי.",
    1027: "מספר העובד (GUI) של המשתמש אינו חוקי.",
    1028: "כתובת האימייל של המשתמש ארוכה או קצרה מדי.",
    1029: "מזהה משתמש (User ID) לא יכול להיות ריק.",
    1030: "שם המשתמש לא יכול להיות ריק.",
	1031: 'כתובת הדוא"ל של המשתמש לא יכולה להיות ריקה.',
    1032: "המשתמש אינו חלק מרשימת מיופי הכוח להסרת הגישה.",
    1033: "המשתמש אינו חלק מרשימת מיופי הכוח להסרת הגישה.",
    1034: "המשתמש כבר חלק מרשימת מיופי הכוח.",
    1035: "מספר משתמש מזוהה (User ID) אינו מתאים. נסה שוב עם מספר משתמש מזוהה נכון.",
    1036: "משתמש מחובר לא יכול להיות חלק מהרשימה. בבקשה נסה שוב מאוחר יותר.",
    1040: "אין לך זכויות מנהל. אנא צור קשר עם דלפק העזרה.",

    7001: "הבקשה לנתוני תיק הביקורת ('Engagements metadata) נכשלה.",
    7006: "לא ניתן לגשת ל- EY Canvas כעת. רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).",

    8003: "שגיאה בעת קבלת פרטי תיק הביקורת מה- CDS API.",
    8006: "לא ניתן לגשת ל- EY Canvas כעת. רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).",
    8004: "קוד ההתקשרות לא נמצא. אם זהו קוד מרקורי, ודא שסוג ההתקשרות נכלל. נסה שוב ואם הבעיה ממשיכה, אנא פנה לתמיכה הטכנית.",
    8007: "שגיאה בעת קבלת פרטי תיק הביקורת מה- CDS API.",
    8008: "החיבור נכשל. רענן ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",

    9001: "הבקשה אינה יכולה להיות ריק",
    9002: "השדה 'קוד פרוייקט לקוח' אינו יכול להיות ריק",
    9003: "השדה 'שם פרוייקט' אינו יכול להיות ריק.",
    9004: "השדה 'אחוזים' אינו יכול להיות ריק",
    9005: "שדה התעריף אינו יכול להיות ריק.",
    9006: "לתקציב לא משויכת התקשרות נבחרת.",
    9007: "המזהה הייחודי של תיק הביקורת אינו יכול להיות ריק.",
    9008: "שם לקוח הביקורת אינו יכול להיות ריק.",
    9009: "תיאור תיק הביקורת אינו יכול להיות ריק.",
    9010: "המזהה הייחודי של לקוח תיק הביקורת אינו יכול להיות ריק.",
    9011: "מערכת תיק הביקורת המקושר אינה יכולה להיות ריק.",
    9012: "מזהה ייחודי של תיק הביקורת המקושר אינו יכול להיות ריק.",
    9013: "שם תיק הביקורת המקושר אינו יכול להיות ריק.",
    9014: "המזהה הייחודי של לקוח ביקורת קשור אינו יכול להיות ריק.",
    9015: "שם לקוח תיק הביקורת הקשור אינו יכול להיות ריק.",
    9016: "תיק הביקורת הקשור שנוסף על-ידי אינו יכולה להיות ריק.",
    9017: "התקשרות אחת או יותר ב- EY Canvas אינן חוקיות.",
    9018: "אחד או יותר מקודי תיק הביקורת הקשורים אינם חוקיים.",
    9019: "אחוז הפרוייקטים צריך להיות גדול מאפס.",
    9020: "אחוז הפרוייקטים לא צריך להכיל יותר משתי ספרות עשרוניות.",
    9021: "שיעור הפרוייקטים צריך להיות גדול מאפס.",
    9022: "מזהה פרוייקט אינו חוקי",
    9023: "קבלת קריאה לניתוח פיננסי נכשלה.",
    9024: "פרטי הפרוייקט לא נמצאו.",
    9025: "קבלת קריאה לכותרת נכשלה.",
    9026: "אין תוצאות שתואמות את קריטריוני החיפוש.",
    9027: "סוג צבירה לא חוקי.",
    9028: "למשתמש הנוכחי אין גישה לפרוייקט.",
    9029: "פרטי החיוב של הפרוייקט לא נמצאו.",
    9030: "מסננים פיננסיים של פרויקט לא נמצאו.",
    9031: "שם משתמש ארוך מדי או קצר מדי.",
    9032: "GUI של משתמשים אינו חוקי.",
	9033: 'כתובת הדוא"ל של המשתמש היא ארוכה מדי או קצרה מדי.',
    9034: "לפחות חבר צוות אחד צריך להיות בעל תפקיד מנהל פרויקט.",
    9035: "אתה המשתמש האחרון הפעיל של מנהל הפרויקט בפרויקט. מחק את הפרויקט בכדי להסיר אותו מדף הפתיחה (Landing Page) שלך. אם אינך מצליח למחוק את הפרויקט, צור קשר עם התמיכה הטכנית.",
    9036: "אנא הסר התקשרות אחת או יותר של EY Canvas. הכמות חורגת מ-{0}.",
    9037: "אנא הסר כמה חברי צוות, הואיל והכמות עולה על ה -{0}.",
    9038: "אנא הסר כמה קודי תיקי ביקורת, הואיל והכמות עולה על {0}.",
    9039: "מספר משתמשי הפרויקט חייב להיות גדול מאפס.",
    9040: "קודים פיננסיים לא מאושרים אינם יכולים להיות מחרוזות ריקות או ריק ואורכם אינו יכול לעלות על 50 תווים.",
    9041: "מספר מזהה של הפרויקט לא יכול להיות ריק.",
    9042: "לא ניתן להשלים את המחיקה. נסה שוב ואם השגיאה נמשכת, פנה לתמיכה הטכנית.",
    9043: "למשתמש הנוכחי אין גישה לערוך פרויקט.",
    9044: "שיחת פרטי הפרויקט נכשלה.",
    9045: "סטטוס הפרויקט אינו חוקי.",
    9046: "סטטוס משתמש בפרויקט אינו חוקי.",
    9047: "תפקיד משתמש לא חוקי בפרויקט.",
    9048: "שם הפרויקט צריך להיות בטווח של 500 תווים.",
    9049: "השם הפרטי של משתמש הפרויקט לא יכול להיות ריק.",
    9050: "שם המשפחה של משתמש הפרויקט לא יכול להיות ריק.",
    9051: "ה-GUI של משתמש הפרויקט לא יכול להיות ריק.",
    9052: "כתובת האימייל של משתמש הפרויקט לא יכולה להיות ריקה.",
    9053: "דגל הניהול של משתמש הפרויקט לא יכול להיות ריק.",
    9054: "לא ניתן להוסיף חשבון מוגן כמשתמש בפרויקט.",
    9055: "מסנני הוצאות פרויקט לא נמצאו.",
    9056: "גוף בקשת התיקון לבחינת אי התלות בפרויקט לא יכול להיות ריק.",
    9058: "הקודים הכספיים אינם חוקיים.",
    9063: "להצהרת אי התלות המלאה יש בהסבר ערך לא חוקי.",
    9064: "להשלמת הצהרת אי התלות יש ערך לא חוקי.",
    9065: "מסנני הוצאות פרויקט לא נמצאו.",
    9066: "מספר מזהי ההתקשרות המקושרים לפרויקט גדול מהמספר המרבי המותר.",
    9067: "פעולת תיקון לא חוקית.",
    9068: "משתמש מסוים כבר עדכן את הסטטוס, רענן את הדף כדי להציג את הסטטוס האחרון.",
    9069: "ממשק API של תיקון הצהרת אי התלות נכשל.",
    9070: "שכפול קודים כספיים המשויכים להתקשרות של ה EY CANVAS.",
    9071: "ניתן לסמן רק קודים כספיים בודדים המשויכים להתקשרות של ה EY CANVAS כקוד ראשי.",
    9072: "קודים כספיים ראשיים המשויכים להתקשרות של ה EY CANVAS אינם חוקיים.",
    9073: "שכפול קודים כספיים לא מאומתים.",
    9074: "משתמשים כפולים.",
    9075: "אימייל של משתמש אינו חוקי.",
    9076: "גוף הבקשה ליוצר משתמש ההתקשרות לא יכול להיות ריק.",
    9077: "לבקשת יצירת משתמש ההתקשרות יש משתמשים כפולים.",
    9078: "תפקיד משתמש ההתקשרות אינו חוקי.",
    9079: "ההתקשרות של ה EY CANVAS לא חוקית.",
    9080: "תיק הביקורת לא ממופה לפרויקט.",
    9081: "הבקשה ליצירת משתמש ההתקשרות נכשלה.",
    9082: "פג הזמן הקצוב להפעלה עקב חוסר פעילות. רענן את הדף ונסה שוב. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",

    /*Admin error codes*/
    14001: "המשתמש לא נמצא",
    14002: "שיחת מנהל מערכת נכשלה",
    14003: "משתמש מנהל שנמצא הוא InActive",
    14004: "יצירת משתמש מנהל נכשלה",
    14005: "השם הפרטי קצר מדי או ארוך מדי. בבקשה נסה שוב",
    14006: "שם המשפחה קצר מדי או ארוך מדי. בבקשה נסה שוב",
    14007: "מזהה תפקיד המנהל אינו חוקי",
    14008: "המשתמש שנבחר הוא כבר מנהל מערכת. אנא עיין.",
    14009: "שיחת חיפוש משתמש מנהל נכשלה",
    14010: "ממשק משתמש לא יכול להיות ריק",
    14011: "ה-GUI של המשתמש חייב להיות גדול מאפס",
    14012: "זיהוי המשתמש אינו חוקי. בבקשה נסה שוב",
    14013: "כתובת האימייל אינה חוקית. בבקשה נסה שוב",
    14014: "משתמש מחובר אינו זהה למשתמש מנהל",
    14015: "קריאת חיפוש פרויקט מנהל נכשלה",
    14016: "משתמש מנהל כבר קיים אך אינו פעיל",
    14017: "מנהל יכול להיות רק חשבון משתמש בעל הרשאות",
    14018: "מזהה תפקיד מנהל לא יכול להיות ריק.",
    14019: "המשתמש המחובר אינו מנהל מערכת.",
    14020: "חשבון חסוי של מבקש פסול.",
    14021: "מנהל יכול להיות רק חשבון משתמש בעל הרשאות.",
    14023: "שגיאה בהסרת תפקידי מנהל מערכת קיימים.",
    14024: "שגיאה בהוספת תפקידי מנהל מערכת מעודכנים.",
    14025: "מזהה משתמש מנהל לא יכול להיות ריק.",

    /*PAANS error codes*/
    15001: "ה- EY Policy Authoring, Approvals and Notification Service אינו זמין בשלב זה. אין באפשרותנו לאשר אם כל המדיניות הרלוונטית הושלמה. אם לא בדקת את המדיניות הרלוונטית, רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה אל התמיכה הטכנית. "
};

export const roundingOptions = [{
        value: 'none',
        label: "אף אחד"
    },
    {
        value: 'thousands',
        label: "באלפים"
    },
    {
        value: 'millions',
        label: "במיליונים"
    },
    {
        value: 'lakhs',
        label: "ב- Lakhs"
    },
    {
        value: 'crores',
        label: "ב- Crores"
    }
];

export const displayLanguages = [{
        displayLanguageId: 1,
        label: "אנגלית",
        value: 'en-us'
    },
    {
        displayLanguageId: 4,
        label: "צרפתית",
        value: 'fr-ca'
    },
    {
        displayLanguageId: 5,
        label: "ספרדית",
        value: 'es'
    },
    {
        displayLanguageId: 7,
        label: "פורטוגזית",
        value: 'pt-br'
    },
    {
        displayLanguageId: 8,
        label: "יפנית",
        value: 'ja'
    },
    {
        displayLanguageId: 9,
        label: "Chinesezh-cn",
        value: 'zh-cn'
    },
    {
        displayLanguageId: 10,
        label: "Chinesezh-tw",
        value: 'zh-tw'
    },
    {
        displayLanguageId: 11,
        label: "עברית",
        value: 'he'
    },
    {
        displayLanguageId: 12,
        label: "קוריאנית",
        value: 'ko'
    }
];

export const numberFormats = [{
        value: '1,234,567,890',
        label: "סגנון מספר 1",
        title: '1,234,567,890'
    },
    {
        value: '1.234.567.890',
        label: "סגנון מספר 3",
        title: '1.234.567.890'
    },
    {
        value: '1,23,45,67,890',
        label: "סגנון מספר 7",
        title: '1,23,45,67,890'
    },
    {
        value: '1 234 567 890',
        label: "סגנון מספר 2",
        title: '1 234 567 890'
    }
];

export const dateFormats = [{
        value: 'MM/dd/yyyy',
        label: 'MM/DD/YYYY'
    },
    {
        value: 'dd/MM/yyyy',
        label: 'DD/MM/YYYY'
    },
    {
        value: 'yyyy/MM/dd',
        label: 'YYYY/MM/DD'
    }
];

export const negativeNumberFormats = [{
        value: '(1.1)',
        label: '(1.1)'
    },
    {
        value: '-1.1',
        label: '-1.1'
    },
    {
        value: '- 1.1',
        label: '- 1.1'
    },
    {
        value: '1.1-',
        label: '1.1-'
    },
    {
        value: '1.1 -',
        label: '1.1 -'
    }
];

export const currencyFormats = [{
        value: "global",
        label: "Global"
    },
    {
        value: "מקומי",
        label: "מקומי"
    }
];

export const themeOptions = {
    light: "בהיר",
    dark: "כהה"
};

export const currencyOptions = {
    global: "Global",
    local: "מקומי"
};

export const currencyDisplayOptions = [{
        value: 'Global',
        label: "Global"
    },
    {
        value: 'Local',
        label: "מקומי"
    }
];

export const statusValues = [{
        isActive: true,
        label: "פעיל"
    },
    {
        isActive: false,
        label: "לא פעיל"
    }
];

export const financialOptions = {
    serviceLine: "מחלקת שירות (SL)",
    subServiceLine: "תת מחלקת שירות (Sub-SL)",
    teamMember: "חבר צוות",
    rank: "דַרגָה"
};

export const roles = {
    1: "השותף האחראי על תיק הביקורת",
    2: "השותף האחראי על תיק הביקורת",
    3: "ED",
    4: "שותף",
    5: "סניור מנג'ר",
    6: "מנג'ר",
    7: "סניור",
    8: "מתמחה",
    9: "מתמחה",
    10: "שותף מלווה EQR",
    11: "שותף אחר",
    12: "GDS - Staff",
    13: "ייעוץ (ITRA, TAS, הון אנושי או אחר)",
    14: "TAX",
    15: "שירותי תמיכה ניהוליים",
    16: "יועץ משפטי",
    17: "סוקר AQR",
    21: "אחראי על הביקורת הפנימית",
    22: "צוות ביקורת פנימית",
    23: "רגולטור",
    24: "אחר (למשל בדיקה נאותות)",
    25: "משרד",
    26: "אזור",
    27: "תעשייה",
    28: "National",
    29: "Global",
    30: "GDS - Senior",
    31: "GDS - Manager"
};

export const serviceLines = [{
        value: 0,
        label: "כל קווי השירות SL"
    },
    {
        value: 1,
        label: "Advisory"
    },
    {
        value: 2,
        label: "Assurance"
    },
    {
        value: 3,
        label: "GCO"
    },
    {
        value: 4,
        label: "TAS"
    },
    {
        value: 5,
        label: "TAX"
    },
    {
        value: 6,
        label: "אחרים"
    }
];

export const serviceLinesByServiceLineCode = [{
        code: 'Not available',
        label: "לא זמין"
    },
    {
        code: 'ASU',
        label: "מחויב (מתקיים)"
    },
    {
        code: 'TAS',
        label: "אסטרטגיה ועסקאות"
    },
    {
        code: 'TAX',
        label: "מיסים"
    },
    {
        code: 'ADV',
        label: "ייעוץ"
    },
];

export const userRanks = [{
        id: '11',
        name: "שותף"
    },
    {
        id: '12',
        name: "שותף"
    },
    {
        id: '13',
        name: "ED"
    },
    {
        id: '21',
        name: "Sr. Manager"
    },
    {
        id: '32',
        name: "מנג'ר"
    },
    {
        id: '36',
        name: "Tax Manager"
    },
    {
        id: '4',
        name: "קבלן"
    },
    {
        id: '41',
        name: "Senior 3"
    },
    {
        id: '42',
        name: "סניור"
    },
    {
        id: '43',
        name: "Staff 2"
    },
    {
        id: '44',
        name: "מתמחה"
    },
    {
        id: '45',
        name: "Senior 2"
    },
    {
        id: '46',
        name: "Staff 3"
    },
    {
        id: '49',
        name: "חָבֵר"
    },
    {
        id: '5',
        name: "Administrative contractor"
    },
    {
        id: '51',
        name: "מתמחה"
    },
    {
        id: '52',
        name: "Admin Support"
    },
    {
        id: '53',
        name: "עובד חדש (CBS)"
    },
    {
        id: '55',
        name: "Admin Lead"
    },
    {
        id: '56',
        name: "Admin Advanced"
    },
    {
        id: '57',
        name: "Admin Intermediate"
    },
    {
        id: '58',
        name: "Admin Entry"
    },
    {
        id: '61',
        name: "Director"
    },
    {
        id: '62',
        name: "Associate Director"
    },
    {
        id: '63',
        name: "Assistant Director"
    },
    {
        id: '64',
        name: "Supervising Associate"
    },
    {
        id: '65',
        name: "Sr. Associate"
    },
    {
        id: '66',
        name: "חָבֵר"
    },
    {
        id: 'Not available',
        name: "לא זמין"
    }
];

export const financialAnalysis = {
    noResultFound: "לא נמצאו תוצאות עבור האפשרויות שנבחרו",
    allServiceLines: "כל קווי השירות SL",
    allSubServiceLines: "כל תתי המחלקות (SSL)",
    allMembers: "כל חברי הצוות",
    allAvailable: "הכל זמין",
    allAdded: "כולם נוספו",
    selectAll: "בחר הכל",
    noResult: "לא נמצאו תוצאות",
    noneSelected: "לא נבחר כלום",
    clearAllSeleted: "נקה # נבחר",
    showSelected: "הצג את הפריטים שנבחרו",
    allRanks: "כל הדרגות"
};

export const independenceStatus = [{
        value: 1,
        label: "לא הושלם - לא הוזמן"
    },
    {
        value: 2,
        label: "לא הושלם - בתהליך"
    },
    {
        value: 3,
        label: "הושלם - אחר"
    },
    {
        value: 4,
        label: "הושלם - מאומת ב-EY Canvas"
    }
];

export const eycanvasIndependenceStatus = [{
        value: 1,
        label: "לא הושלם"
    },
    {
        value: 2,
        label: "לא זוהו סוגיות"
    },
    {
        value: 3,
        label: "זוהתה סוגייה - פעולה בהמתנה"
    },
    {
        value: 4,
        label: "נפתרה הסוגייה - נחסמה גישה"
    },
    {
        value: 5,
        label: "נפתרה הסוגייה - הוענקה גישה"
    },
    {
        value: 6,
        label: "לא ישים"
    },
    {
        value: 7,
        label: "שוחזר"
    },
    {
        value: 8,
        label: "לעקוף"
    },
    {
        value: 9,
        label: "לפני - לא זוהו סוגיות"
    },
    {
        value: 10,
        label: "לפני - זוהתה סוגיה - פעולה בהמתנה"
    },
    {
        value: 11,
        label: "לפני - הסוגיה נפתרה - הוענקה גישה"
    },
    {
        value: 12,
        label: "לפני - הסוגיה נפתרה - הגישה נחסמה"
    }
];

export const availableUserRoles = [{
	value: 1,
	label: "השותף האחראי על תיק הביקורת",
	displayOrder: 9
},
{
	value: 2,
	label: "השותף האחראי על תיק הביקורת",
	displayOrder: 8
},
{
	value: 3,
	label: "ED",
	displayOrder: 5
},
{
	value: 4,
	label: "שותף",
	displayOrder: 6
},
{
	value: 5,
	label: "סניור מנג'ר SM",
	displayOrder: 4
},
{
	value: 6,
	label: "מנג'ר",
	displayOrder: 3
},
{
	value: 7,
	label: "סניור",
	displayOrder: 2
},
{
	value: 8,
	label: "מתמחה",
	displayOrder: 1
},
{
	value: 10,
	label: "שותף מלווה EQR",
	displayOrder: 10
},
{
	value: 11,
	label: "שותף אחר",
	displayOrder: 7
},
{
	value: 12,
	label: "GDS - Staff",
	displayOrder: 13
},
{
	value: 16,
	label: "יועץ משפטי",
	displayOrder: 12
},
{
	value: 17,
	label: "סוקר AQR",
	displayOrder: 11
},
{
	value: 30,
	label: "GDS - Senior",
	displayOrder: 14
},
{
	value: 31,
	label: "GDS - Manager",
	displayOrder: 15
}
]

export const employmentStatus = [{
        value: 'A',
        label: "פעיל"
    },
    {
        value: 'D',
        label: "הסתיים"
    },
    {
        value: 'L',
        label: 'חופשה ללא תשלום (חל"ת)'
    },
    {
        value: 'T',
        label: "הסתיים"
    },
    {
        value: 'P',
        label: 'חופשה ללא תשלום (חל"ת)'
    },
    {
        value: 'R',
        label: "הסתיים"
    },
    {
        value: 'U',
        label: 'חופשה ללא תשלום (חל"ת)'
    },
]

export const independenceStatusDropdown = [{
        label: "לא הושלם",
        options: [{
                value: 1,
                label: "לא הושלם - לא הוזמן"
            },
            {
                value: 2,
                label: "לא הושלם - בתהליך"
            }
        ]
    },
    {
        label: "המשימות למענה  בביקורת הושלמו",
        options: [{
            value: 3,
            label: "הושלם - אחר"
        }]
    }
];

export const customizedTableOptions = [{
        id: 2,
        label: "סטטוס אי התלות ב EY Canvas"
    },
    {
        id: 3,
        label: "פירמה ברשת"
    },
    {
        id: 4,
        label: "מדינה"
    },
    {
        id: 5,
        label: "שעות שחויבו"
    },
    {
        id: 6,
        label: "סטטוס אי התלות - כללי"
    },
    {
        id: 7,
        label: "תאריך אישור"
    },
    {
        id: 8,
        label: "מצב תעסוקה"
    },
    {
        id: 9,
        label: "עודכן על ידי"
    },
    {
        id: 10,
        label: "תאריך עדכון"
    }
];

export const independenceStatusChangeReasons = [{
        value: 1,
        label: "הושלם מחוץ ל-EY Canvas - No Matters Identified",
        isDisplayed: true
    },
    {
        value: 7,
        label: "הושלם מחוץ ל-EY Canvas - Matters Identified",
        isDisplayed: true
    },
    {
        value: 8,
        label: "הושלם מחוץ ל-EY Canvas - Matters Resolved",
        isDisplayed: true
    },
    {
        value: 2,
        label: "תמיד נחשב ל covered person",
        isDisplayed: true
    },
    {
        value: 3,
        label: "כבר לא בחברה",
        isDisplayed: true
    },
    {
        value: 4,
		label: 'חופשה ללא תשלום (חל"ת)',
        isDisplayed: true
    },
    {
        value: 5,
        label: "הסתיים",
        isDisplayed: false
    },
    {
        value: 6,
        label: "אחרים",
        isDisplayed: false
    }
];

export const common = {
    selected: "המשתמש שנבחר",
    cancel: "בטל",
    checkbox: {
        selectAllOn: "בחר הכל",
        selectAllOff: "בטל את הבחירה בכולם"
    },
    clear: "Clear",
    close: "Close",
    nav: {
        projectName: "שם הפרוייקט"
    },
    pagination: {
        show: "‏הצג",
        iconHover: {
            first: "הדף הראשון",
            previous: "הדף הקודם",
            next: "הדף הבא",
            last: "הדף האחרון"
        }
    },
    search: {
        clear: "נקה חיפוש",
        buttonTitle: "חפש",
        placeholder: "חפש",
        noResultsPlaceholder: "לא נמצאו תוצאות"
    },
    table: {
        remove: "הסר",
        noDataPlaceholder: "אין נתונים זמינים",
        noResultsPlaceholder: "לא נמצאו תוצאות"
    },
    toggleSwitch: {
        no: "לא",
        yes: "כן"
    },
    wizard: {
        next: "המשך",
        back: "חזור",
        finish: "סיים"
    },
    unsavedChanges: "שינויים שלא נשמרו",
    unsavedChangesDescription: "יש לך שינויים שלא נשמרו שיאבדו אם תבחר להמשיך. האם אתה בטוח שברצונך לבטל את השינויים שלך?"
};

export const project = {
    myProjects: "הפרוייקטים שלי",
    priorProjects: "חפש",
    searchForBudgets: "חפש",
	emptyContainer: 'אין לך שום תקציב פעיל. לחץ "צור תקציב" כדי להתחיל.',
    noResultsFound: "לא נמצאו תוצאות",
    create: {
        title: "צור פרוייקט",
        clientCode: "קוד לקוח",
        clientCodeInfo: "קודים מסוג Mirror codes אינם מזוהים. השתמש בקוד שהמערכת הפיקה (כלומר Mercury or GFIS).",
        clientName: "שם הלקוח",
        clientNamePlaceholder: "הזן קוד לקוח כדי לאתר את שם הלקוח",
        name: "שם הפרוייקט",
        rate: "תעריף ברירת מחדל לשעה",
        rateInfo: "תעריף ברירת מחדל לשעה ישמש לחישוב ערך השעות המתוקצבות. יש לחשב תעריף זה כעמלות שיחויייבו חלקי סך השעות הצפויות.",
        percentage: "אחוז ה- realization הצפוי",
        percentageInfo: "אחוז  ה- realization הצפוי יוחל על ערך הזמן של שעות שנגבו ב- Mercury or GFIS.",
        relateEngagementsInstructionalText: "בחר תיק ביקורת EY Canvas אחד או יותר שישמשו בפרויקט זה. מדדים מתיקי ביקורת אלה יוצגו לצד נתונים פיננסיים. רק תיקי ביקורת נגישים שהינם נגישים כעת יוצגו.",
        selectClientAndWorkspaceInstructionalText: "בחר לקוח וסביבת עבודה כדי לזהות תיק ביקורת EY Canvas שיהיו קשורוים לפרויקט זה.",
        engagementPanelPlaceholder: "בחר לקוח וסביבת עבודה כדי להציג תיקי ביקורת מוצעים.",
        engagementPanelNoResultsFound: "לא נמצאו תוצאות",
        emptyEngagements: "אין תיקי ביקורת EY Canvas זמינים. צור תיק ביקורת חדש ב- EY Canvas כדי להתחיל.",
        selectClient: "בחר לקוח",
        selectWorkspace: "בחר סביבת עבודה",
        selectEngagements: "בחר התקשרות",
        selectedEngagements: "תיקי ביקורת שנוספו",
        selectedEngagementError: "בחר תיק ביקורת אחד או יותר על מנת להמשיך",
        searchEngagements: "חיפוש תיקי ביקורת",
        searchUsers: "חיפוש משתמשים",
        engagementLabel: "{0} | מזהה: {1}",
        addBtn: "הוסף",
        removeBtn: "הסר",
        clientLbl: "לקוח",
        engagementCodeLbl: "קוד התקשרות",
        engagementTypeCodeLbl: "סוג תיק ביקורת",
        engagementNameLbl: "שם ההתקשרות",
        engagementId: "ID",
        addedByLbl: "נוסף על ידי",
        engagementDescriptionLbl: "תיאור תיק ביקורת",
        systemLbl: "מערכת",
        noEngagementsLabel: "קשר קודי תיק ביקורת לפרויקט זה",
        step4InstTxt: "בחר קוד התקשרות אחד או יותר שישויך לפרוייקט.",
        relatedEngagementCodesSubtitle: "קשר קודי תיק ביקורת לפרויקט זה",
        relatedEngagementCodeLink: "קשר קוד תיק ביקורת מ- Mercury or GFIS. קודים מסוג mirror codes אינם מזוהים.",
        unauthorizedModalHeader: "משתמש ללא הרשאות",
        unauthorizedText: "אינך מורשה לקשר",
        allowedUsersText: "להלן רשימה של אנשים שיכולים לבצע פעולה זו.",
        closeBtn: "Close",
        validateBtn: "לאמת",
        relatedEngagementAddLabel: "קשר קוד תיק ביקורת מ- Mercury or GFIS. קודים מסוג mirror codes אינם מזוהים.",
        todayLbl: "היום",
		NoEmailMessage: 'לא סופק דוא"ל',
        noEngagementsAdded: "לא נוספו תיקי ביקורת",
        selectToImport: "בחר תיק ביקורת EY Canvas לייבוא משתמשים לפרויקט זה.",
        addMember: "אם משתמש אינו פעיל בהתקשרות ב- EY Canvas, {0} כדי להוסיף אותם.",
        addedMembers: "חברים שנוספו",
        employeeName: "חבר",
        role: "Role",
        manageTeamInstructionalText: "בחר חברי צוות פעילים מתיקי הביקורת EY Canvas הקשורים, עקוב אחר התיאור שלהלן כדי להוסיף חברי צוות אחרים שאינם חלק מתיקי הביקורת EY Canvas.",
        currentUser: "משתמש נוכחי",
        canvasEngagements: "התקשרויות של EY Canvas",
		wizardSteps: [
			{
                stepName: "שלב 1",
                stepDescription: "הזן פרטי פרוייקט",
                active: true
            },
            {
                stepName: "שלב 2",
                stepDescription: "בחר התקשרויות ב- EY Canvas"
            },
            {
                stepName: "שלב 3",
                stepDescription: "ניהול גישה",
                relatedEngagementCodesSubtitle: "קשר קודי תיק ביקורת לפרויקט זה",
                relatedEngagementCodeLink: "קשר קוד תיק ביקורת מ- Mercury or GFIS. קודים מסוג mirror codes אינם מזוהים.",
                unauthorizedModalHeader: "משתמש ללא הרשאות",
                unauthorizedText: "אינך מורשה לקשר",
                allowedUsersText: "להלן רשימה של אנשים שיכולים לבצע פעולה זו",
                close: "Close"
            },
            {
                stepName: "שלב 4",
                stepDescription: "תעריף לשעה"
            },
            {
    stepName: 'Step 5',
    stepDescription: "שייך קודים של תיק הביקורת להתקשרויות ב- EY Canvas",
    isExit: true
 }
        ],
        ratePerHour: "תעריף לשעה",
        realizationPercentage: "אחוז realization"
    },
    stepOne: {
        enterProjectName: "הזן שם פרוייקט כדי להמשיך"
    },
    stepTwo: {
        addCanvasEngagements: "הוסף התקשרויות של EY Canvas לפרויקט",
        editCanvasEngagements: "ערוך התקשרויות של EY Canvas לפרויקט",
        selectCanvasEngagements: "התקשרויות EY Canvas שיש לך גישה אליהן מוצגות. בחר התקשרות אחת או יותר של EY Canvas שיכללו בפרויקט.",
        noCanvasEngagements: "אין התקשרויות זמינות של EY Canvas. המשך לשלב הבא בכדי להמשיך בהגדרת הפרויקט.",
        noCanvasEngagementsSelected: "לא נבחרו התקשרויות של EY Canvas",
        noSearchResultsFoundLeftRail: "לא נמצאו תוצאות",
        clientName: "לקוח",
        workspace: "סביבת עבודה",
        engagementCode: "קוד התקשרות",
        canvasEngagementName: "התקשרות ב- EY Canvas",
        changes: "שינויים",
        tooltipMessages: {
            clientName: "שם הלקוח",
            clientCode: "קוד לקוח",
            engagementCode: "קוד התקשרות",
            engagementDescription: "שם ההתקשרות",
            workspaceID: "מזהה סביבת עבודה",
            workspaceDescription: "שם סביבת העבודה"
        }
    },
    stepThree: {
        editTeamMembers: "ערוך את חברי הצוות לפרויקט",
        editTeamMembersWhoWillHaveAccess: "ערוך את חברי הצוות שתהיה להם גישה לפרויקט. כדי להוסיף חבר צוות שאינו חלק מתיקי הביקורת הקשורים ב- Canvas, השתמש באופציית החיפוש בצד ימין. למנהלי הפרויקטים תהיה אפשרות לנהל את הפרויקט (למשל, להוסיף או להסיר חברי צוות).",
        addTeamMembers: "הוסף חברי צוות לפרויקט",
        addTeamMembersWhoWillHaveAccess: "הוסף חברי צוות שתהיה להם גישה לפרויקט. כדי להוסיף חבר צוות שאינו חלק מתיקי ביקורת קשורים  ב Canvas, השתמש באופציית החיפוש בצד ימין. למנהלי הפרויקטים תהיה אפשרות לנהל את הפרויקט (למשל, להוסיף או להסיר חברי צוות).",
        noCanvasEngagementsSelected: "לא נבחרו התקשרויות של EY Canvas",
        noSearchResultsFoundLeftRail: "לא נמצאו תוצאות",
        addOtherTeamMembers: "הוסף חברי צוות אחרים שאינם חלק מההתקשרויות המחוברות של ה- EY Canvas.",
        member: "חבר",
        projectAdministrator: "מנהל פרויקט",
        clickHere: "לחץ כאן",
		nameOrEmail: 'שם או דוא"ל',
        addNewMember: "הוסף",
        firstName: "שם פרטי",
        lastName: "שם משפחה",
        inviteAndClose: "הזמן וסגור",
        inviteAndAddAnother: "הזמן והוסף נוסף",
        clear: "Clear"
    },
    stepFour: {
        engagementCode: "קוד התקשרות",
        clientName: "לקוח",
        validation: "סטטוס",
        independenceOnly: "אי תלות בלבד",
        noEngagementCodes: "לא נוספו קודי תיק הביקורת לפרויקט",
        addNewMember: "הוסף",
        addEngagementManually: "הוסף קודי תיק הביקורת",
        addEngagementCodes: "הוסף קודי תיק הביקורת",
        editEngagementCodes: "ערוך קודי התקשרות",
        validateEngagement: "אמת את כל הקודים שנוספו לתיק הביקורת. ניתן לאמת רק קודי תיק ביקורת שיש לך גישה אליהם ב-GFIS/Mercury. אם קוד תיק ביקורת מזוהה כ\'אי תלות בלבד\', פרטים הקשורים לקוד תיק ביקורת זה (כגון חברי צוות ושעות לחיוב) ייכללו בסיכום אי בתלות של פרויקט Economics זה אך לא ייכללו בתקשור המידע הפיננסי.",
        informationalMessage: "עבור מרקורי, כלול את סוג תיק הביקורת כתחילית לקוד תיק הביקורת (למשל, E-12345678)",
        noCanvasEngagements: "לא נוספו התקשרויות של EY Canvas לפרויקט",
        engagementCodePlaceholder: "הזן קוד תיק ביקורת",
        validate: "לאמת",
        engagementCodeRequired: "קוד תיק ביקורת נדרש",
        searchNoResults: "לא נמצאו תוצאות"
    },
stepFive: {
    title: "שייך קודים של תיק הביקורת להתקשרויות ב- EY Canvas",
    description: "קודי תיק הביקורת העיקריים המשויכים לכל אחת מההתקשרויות המחוברות של ה- EY Canvas מוצגים להלן. כדי לשייך קודי תיק ביקורת נוספים להתקשרות ב- EY Canvas, השתמש בפונקציונליות ה'גרור ושחרר' שלהלן.",
    financialCodes: {
        searchButtonTitle: "חפש",
        searchButtonPlaceholder: "חפש לפי קוד ההתקשרות",
        header: "קודים לתיק הביקורת",
        noRecords: "לא זוהו קודים לתיק הביקורת",
        canvasEngagements: "התקשרויות של EY Canvas",
        noResults: "לא נמצאו תוצאות"
    },
    canvasEngagements: {
        searchButtonTitle: "חפש",
        clearButtonTitle: "Clear",
        noResults: "לא נמצאו תוצאות",
        searchButtonPlaceholder: "חפש לפי לקוח או התקשרות EY Canvas",
        header: "לקוחות והתקשרויות",
        noRecords: "אין התקשרויות של EY Canvas הקשורות לפרויקט",
        noEngagementCodes: "אין קודים המשויכים לתיק הביקורת",
        primary: "צוות ראשי",
        displayUnassociatedEngagements: "הצג התקשרות(יות) של EY Canvas ללא קודי התקשרות"
    }
},
    deleteProject: "מחק פרויקט",
    deleteDescription: "האם אתה בטוח שברצונך למחוק את הפרויקט עבור כל המשתמשים?",
    deleteDescText: "לא ניתן לבטל פעולה זו.",
    delete: "מחק",
    cancel: "בטל",
    close: "Close",
    confirm: "אשר",
    leaveProject: "לעזוב",
    leaveDescription: "האם אתה בטוח שאתה רוצה לעזוב את הפרויקט הזה? הוא ימשיך להיות זמין עבור חברי הצוות שלך.",
    change: "שינוי",
    changes: "שינויים"
};

export const users = {
    settings: {
        title: "הגדרות משתמש",
        firstName: "שם פרטי",
        lastName: "שם משפחה",
        displayLanguage: "שפת התצוגה",
        numberFormat: "תבנית מספרית",
        negativeNumberFormat: "תבנית מספר שלילי",
        currencyFormat: "תבנית מטבע",
        dateFormat: "תבנית תאריך",
        roundingFormat: "תבנית עיגול",
        save: "שמור",
        cancel: "בטל",
        errorMessageSelect: "נא בחר ערך.",
        errorMessageInput: "נא הזן ערך חוקי.",
        isRequired: " נדרש.",
        preferences: "העדפות",
        yourDelegates: "העברת המשימות שביצעת",
        yourDelegatesDescription: "משתמשים שהענקת להם סמכות לאחזר נתונים פיננסיים/כספיים לקודי תיק ביקורת אליהם יש לך גישה ב- Mercury או ב- GFIS",
        delegationsFromOthers: "העברת משימות מאחרים",
        delegationsFromOthersDescription: "משתמשים שהעניקו לך סמכות לאחזר נתונים פיננסיים לתיק ביקורת שיש להם גישה ב- Mercury או ב- GFIS",
        noUsersIdentified: "לא זוהו משתמשים",
        addADelegate: "הוספת מיופה כוח",
        theme: "נושא",
        preferredCurrency: "מטבע מועדף",
        status: "סטטוס"
    }
};

export const projectSummary = {
    filter: {
        filterFinancialAuditData: "סנן לקוחות",
        filter: "סנן",
        searchPlaceholder: "חפש",
        searchClearHoverText: "Clear",
        searchHoverText: "חפש",
        unvalidated: "לא מאומת",
        noData: "לא קושרו התקשרויות של EY Canvas",
        noResults: "לא נמצאו תוצאות",
        noInformationAvailable: "אין מידע זמין לגבי האפשרויות שנבחרו.",
        independence: "אי תלות",
        noDataFound: "לא נמצאו נתונים",
    },
    roundingType: "עיגול:",
    roundingFormats: {
        none: "אף אחד",
        thousands: "באלפים",
        millions: "במיליונים",
        lakhs: "ב- Lakhs",
        crores: "ב- Crores"
    },
    updatedDateType: {
        financialDateLabel: "מידע פיננסי",
        updatedOn: "עודכן ב",
        canvasDateLabel: "נתוני EY Canvas"
    },
    keyPerformanceIndicators: {
        noValue: '-',
        totalEngagementRevenue: {
            ter: "TER",
            actualTER: "TER בפועל",
            billed: "מחוייב",
            actualBilling: "חיוב בפועל",
			totalEngagementRevenue: 'סה"כ רווח מתיק הביקורת (שכ"ט + הוצאות)',
            forecastedTER: "TER צפוי"
        },
        margin: {
            margin: "מרווח",
            target: "יעד"
        },
        globalDeliveryService: {
            gds: "שימוש ב- GDS",
            globalDeliveryService: "Global Delivery Service"
        }
    },
    currency: "מטבע",
    globalCurrency: "Global",
    localCurrency: "מקומי",
    noDataAvailable: "אין נתונים זמינים עבור המסננים שנבחרו",
    actualHours: "שעות בפועל",
    etc: "ETC",
    ftaVariance: "שונות FTA",
    completedTasks: "משימות שהושלמו",
    closedAssignments: "משימות סגורות",
    acceptedRequests: "בקשות שהתקבלו",
    gDSUsage: "שימוש ב- GDS",
    summaryHeaderPartner: "שותף",
    summaryHeaderPpedd: "PPEDD",
    summaryHeaderExecutive: "Executive",
    financialProgressCard: {
        financialProgress: "התקדמות פיננסית",
        financialDetails: "נתונים פיננסיים",
        ansr: "ANSR",
        nsr: "NSR",
		ansrTooltip: 'הכנסה סטנדרטית מתוקננת נטו (שכ"ט נטו לא כולל הוצאות)',
        nsrTooltip: "הכנסה בתעריף רגיל נטו (תעריף לשעה לעובד * שעות עבודה)",
        eafTooltip: "גורם לעדכון ההתקשרות",
        cost: "עלות",
        hours: "שעות",
        expandDetails: "הרחב פרטים",
        expand: "הרחב",
        collapse: "צמצם",
        collapseDetails: "צמצם פרטים",
        margin: "מרווח",
        marginPercentage: "מרווח",
        rphAcronym: "RPH",
        cphAcronym: "CPH",
        mphAcronym: "MPH",
        eafAcronym: "EAF",
        actual: "בפועל",
        budgeted: "מתוקצב",
        forecasted: "צפוי",
        ftaVariance: "שונות FTA",
        ftaVarianceTooltip: "תחזית לשונות מול בפועל",
        rph: "תעריף לשעה",
        cph: "עלות לשעה",
        mph: "מרווח לשעה",
        ansrCost: "NSR / עלות",
        serviceLine: "מחלקת שירות (SL)",
        subServiceLine: "קו שירות משנה (Sub-service Line)",
        teamMember: "חבר צוות",
		totalAnsr: 'סה"כ NSR',
		totalCost: "עלות כוללת",
		totalHours: 'סה"כ שעות',
        ansrLabelText: "הכנסה בתעריף רגיל נטו",
        rank: "דַרגָה",
        performanceActuals: "ביצועים"
    },
    financialAnalysis: {
        show: "‏הצג",
        first: "ראשון",
        last: "אחרון",
        previous: "הקודם",
        next: "הבא"
    },
    financialFilters: {
        serviceLine: "מחלקת שירות (SL)",
        subServiceLine: "קו שירות משנה (Sub-service Line)",
        rank: "דַרגָה",
        teamMember: "חבר צוות",
        showMore: "עוד",
        clear: "Clear",
        clearAll: "נקה הכל",
        search: "חפש",
        noResultsPlaceholder: "אין תוצאות",
        noFiltersAvailable: "ללא מסננים",
        yes: "כן",
        no: "לא",
        tooltip: "סנן",
        expenseType: "סוג הוצאה"
    },
    billingAndExpenses: {
        title: "חיובים בפועל עד כה",
        forecastedTer: "TER צפוי",
        forecastedTerTooltip: "סך ההכנסות החזויות של תיק הביקורת (שכר טרחה + החזרי הוצאות)",
        forecastedBilling: "חיוב צפוי",
        collected: "נגבה",
        collectedTooltip: "נגבה / חויב",
        unCollected: "לא נאסף",
        unCollectedTooltip: "לא נגבה / חויב",
        billed: "מחויב (מתקיים)",
        billedTooltip: "TER שחויב / צפוי",
        billedTotal: "חוייב",
        unbilled: "טרם חויב",
        unbilledTooltip: "TER שלא חויב / צפוי",
        engagementCode: "קוד אינגיגמנט",
        invoiceDate: "תאריך חשבונית",
        currency: "מַטְבֵּעַ",
        invoiceNumber: "מספר חשבונית",
        amount: "סכום",
        noInformationPlaceholder: "אין מידע זמין לגבי האפשרויות שנבחרו.",
        actualTer: "TER בפועל",
		actualTerTooltip: 'סך הכנסות בפועל מתיק הביקורת (שכ"ט + הוצאות)',
        actualExpenseToDate: "הוצאות בפועל עד היום",
        displayBy: "הצג נתונים לפי",
        expenseType: "סוג הוצאה",
        teamMember: "חבר צוות",
        totalExpenseToDate: "סך ההוצאות עד היום",
        expenseTypeColumn: "סוג הוצאה",
        teamMemberColumn: "חבר צוות",
        globalExpenseAmount: "סכום הוצאה גלובלי",
        localExpenseAmount: "סכום הוצאה מקומית",
        billingSummary: "סיכום החיוב",
        billingStatus: "סטטוס החיוב",
        billingTER: "TER",
        serviceLine: "מחלקת שירות (SL)",
        serviceLineColumn: "מחלקת שירות (SL)",
        rank: "דַרגָה",
        rankColumn: "דַרגָה"
    },
    independence: {
        teamMember: "חבר צוות",
        hoursCharged: "שעות שחויבו",
        independenceStatus: "סטטוס אי התלות - כללי",
        confirmationDate: "תאריך אישור",
        memberFirm: "פירמה ברשת",
        eyCanvasIndependenceStatus: "סטטוס אי התלות ב EY Canvas",
        employmentStatus: "מצב תעסוקה",
        country: "מדינה",
        updatedBy: "עודכן על ידי",
        updatedDate: "תאריך עדכון",
        selectColumns: "בחר את העמודות",
        confirmationDateBefore: "תאריך אישור לפני",
        confirmationDateAfter: "תאריך אישור לאחר",
        excelsummary: "סיכום",
        excelMercury: "נתונים מה- Mercury",
        excelCanvas: "נתונים מ-Canvas",
        name: "שם",
        gui: "GUI",
        rank: "דַרגָה",
		emailAddress: 'כתובת הדוא"ל',
        clarification: "הבהרה",
        explanation: "הסבר",
        updatedOn: "עודכן ב",
        client: "לקוח",
        mercuryEngagementCode: "קוד התקשרות ב Mercury",
        canvasEngagement: "תיק ביקורת ב Canvas ",
        email: "דואל",
        reason: "סיבה",
        engagementRole: "תפקיד בהתקשרות",
        location: "Location",
        filter: {
            unassociatedFinancialCodes: "קודים כספיים לא משויכים",
            unassociatedLabel: "לא מקושר",
            filterHeader: "מסנן אי תלות",
            noFinancialCodeLabel: "לא משויך קוד כספי",
            noEngagementLabel: "לא קושרו התקשרויות של EY Canvas",
            expandText: "הרחב",
            collapseText: "צמצם",
            noDataFound: "לא נמצאו נתונים"
        }
    },
    header: {
        hours: "שעות",
        actualHours: "בפועל",
        forecastedHours: "צפוי",
        variance: "שונות FTA",
        other: "אחרים",
        ppedd: "PPEDD",
        mgrSrMgr: "SrMgr/Mgr",
        partnerHours: "שעות שותפים",
        executiveDirector: "ED",
        seniorManager: "סניור מנג'ר",
        manager: "מנג'ר",
        senior: "סניור",
        staff: "מתמחה",
        intern: "מתמחה",
        billed: "מחויב:",
        ter: "TER:",
        forecastedTER: "TER חזוי:",
        margin: "מרווח",
        ansr: "ANSR",
        cost: "עלות",
        terSection: "TER",
        billedSection: "חוייב",
        forecastedTERSection: "צפוי",
        forecastedTERSectionForHeader: "TER חזוי",
        completedTasks: "משימות שהושלמו",
        completedAssignments: "משימות סגורות",
        acceptedRequests: "בקשות שהתקבלו",
        gdsUsage: "שימוש ב- GDS",
        completedTasksTooltip: "הושלם",
        totalTasksTooltip: "סך הכול",
        completedAssignmentsTooltip: "סגור",
        totalAssignmentsTooltip: "סך הכול",
        acceptedRequestsTooltip: "התקבל",
        sentRequestsTooltip: "נשלח",
        gdsHoursTooltip: "GDS",
        actualHoursTooltip: "שעות בפועל",
        otherTooltip: "אחר",
        otherHeaderTooltip: "אחר",
        ppeddTooltip: "PPEDD",
        mgrSrMgrTooltip: "SrMgr/Mgr",
        partnerHoursTooltip: "שותף",
        executiveDirectorTooltip: "ED/D",
        seniorManagerTooltip: "סניור מנג'ר",
        managerTooltip: "מנג'ר",
        seniorTooltip: "סניור",
        staffTooltip: "מתמחה",
        internTooltip: "מתמחה",
        varianceTooltip: "שינויים בין התחזית לפועל ",
		ansrTooltip: 'הכנסה סטנדרטית מתוקננת נטו (שכ"ט נטו לא כולל הוצאות)',
		marginTooltip: "מרווח = (ANSR - עלות) / ANSR",
		terSectionHover: 'סך הכנסות בפועל מתיק הביקורת (שכ"ט + הוצאות)',
        forecastedTERSectionHover: "סך ההכנסות החזויות של תיק הביקורת (שכר טרחה + החזרי הוצאות)",
        billedSectionHover: "סכום החשבונית נטו בפועל",
        gdsUsageHover: "שימוש ב- GDS (Global Delivery Service)"
    }
};

export const exportOptions = {
    buttonText: "ייצא",
    downloadCSV: "הורד CSV",
    downloadJPEG: "הורד JPEG",
    downloadPDF: "הורד PDF",
    downloadPNG: "הורד PNG",
    downloadSVG: "הורד SVG",
    downloadXLS: "הורד XLS",
    exitFullscreen: "יציאה ממסך מלא",
    viewFullscreen: "הצג מסך מלא",
    printChart: "הדפס תרשים"
};

export const adminLabels = {
    adminPortal: "מִנהָל",
    usersTab: "ניהול משתמשים",
    projectsTab: "ניהול פרוייקטים",
    administrators: "ניהול מנהלים"
};

export const projectUserStatus = {
    active: "פעיל",
    inactive: "לא פעיל"
};

export const projectUserRoles = {
    defaultUser: "משתמש ברירת מחדל",
    projectAdministrator: "מנהל פרויקט"
};

export const projectStatus = {
    active: "פעיל",
    deleted: "נמחק"
};

export const administratorRoles = {
    none: "אף אחד",
    adminReader: "קורא אדמין",
    adminWriter: "כותב אדמין",
    superAdmin: "Super admin"
}

export const addUser = {
    firstName: "שם פרטי",
    lastName: "שם משפחה",
    enterFirstNameText: "הזן שם פרטי שם משפחה או כתובת דואר אלקטרוני של המשתמש ולחץ על Enter כדי לחפש",
    selectRole: "Role",
    userRole: "תפקיד משתמש",
    clear: "Clear",
    email: "דואל",
    role: "Role",
    cancel: "בטל",
    addUser: "הוסף משתמש",
    close: "Close",
    add: "הוסף",
    addAdministrator: "הוסף מנהל",
    error1: "המשתמש שנבחר כבר חלק מהפרויקט. אנא עיין.",
    error2: "מנהל יכול להיות רק חשבון משתמש בעל הרשאות"
};

export const adminManageProjects = {
    manageProjects: "ניהול פרויקטים",
    description: "חפש פרויקט על ידי הזנת מזהה הפרויקט",
    projectId: "מזהה פרוייקט",
    search: "חפש",
    clearSearch: "Clear",
    enterValidProject: "הזן מזהה פרויקט חוקי",
    projectDetails: "פרטי הפרוייקט",
    enterProjectName: "הזן את שם הפרויקט",
    projectName: "שם הפרוייקט",
    projectStatus: "סטטוס הפרוייקט",
    financialCodes: "קודים פיננסיים",
    noFinancialCodes: "אין קודי מעורבות פיננסית ממופים לפרויקט זה",
    engagementCode: "קוד אינגיגמנט",
    client: "לקוח",
    status: "סטטוס",
    validatedBy: "מאומת על ידי",
    canvasEngagements: "התקשרויות של EY Canvas",
    canvasEngagement: "התקשרות ב- EY Canvas",
    noCanvasEngagements: "אין התקשרויות של EY Canvas הממופים לפרויקט זה",
    member: "חברי צוות",
    gui: "משתמש",
    firstName: "שם פרטי",
    lastName: "שם משפחה",
	emailAddress: 'כתובת הדוא"ל',
    userRole: "תפקיד משתמש",
    validated: "מאומת",
    unvalidated: "לא מאומת",
    enterValidGui: "הזן GUI חוקי עבור מזהה הפרויקט",
    requiredProjectName: "שם הפרויקט לא יכול להיות ריק",
    successToastMessage: "השינויים נשמרו בהצלחה",
    resetToastMessage: "האיפוס הושלם",
    errorToastMessage: "לפחות חבר אחד בפרויקט נדרש להיות מנהל פרויקט. אנא עיין בשינויים.",
    independenceOnly: "אי תלות בלבד",
    yes: "כן",
    no: "לא"
};

export const manageAdministrators = {
    title: "ניהול מנהלי מערכת",
    firstName: "שם פרטי",
    lastName: "שם משפחה",
    email: "דואל",
    role: "Role",
    description: "הוסף מנהלי מערכת חדשים או נהל מנהלי מערכת קיימים",
    noInformationPlaceholder: "אין מידע זמין לגבי האפשרויות שנבחרו.",
    updateAdminErrorToast: "העדכון לא הצליח. אנא בדוק ונסה שוב מאוחר יותר.",
    updateAdminSuccessToast: "השינויים נשמרו בהצלחה",
};

export const adminManageUsers = {
    title: "ניהול משתמשים",
    description: "חפש משתמש על ידי הזנת GUI של המשתמש שלו",
    inputLabel: "GUI משתמש",
    searchButtonLabel: "חפש",
    cancelButtonLabel: "Clear",
    errorMessage: "הזן משתמש GUI חוקי",
    userDetails: "פרטי המשתמש",
    projects: "פרויקטים",
    delegates: "נציגים",
    settings: "הגדרות",
    noResultsPlaceholder: "לא נמצאו רשומות",
    delegatedTo: "הוקצו ל:",
    delegatedFrom: "מואצל מ:",
    gui: "משתמש",
    firstName: "שם פרטי",
    lastName: "שם משפחה",
	emailAddress: 'כתובת הדוא"ל',
    projectName: "שם הפרוייקט",
    projectId: "מזהה פרוייקט"
};

export const adminCommon = {
    save: "שמור",
    reset: "אִתחוּל"
}
